import {
  Component,
  OnInit
} from '@angular/core';

import {
  SkyDatepickerCalendarInnerComponent
} from './datepicker-calendar-inner.component';

import {
  SkyDatepickerDate
} from './datepicker-date';


export class SkyYearPickerComponent implements OnInit {
  public datepicker: SkyDatepickerCalendarInnerComponent;
  public title: string;
  public rows: Array<Array<SkyDatepickerDate>> = [];

  public constructor(datepicker: SkyDatepickerCalendarInnerComponent) {
    this.datepicker = datepicker;
  }

  public ngOnInit(): void {

    this.datepicker.stepYear = {years: this.datepicker.yearRange};

    this.datepicker.setRefreshViewHandler(() => {
      this.refreshYearView();
    }, 'year');

    this.datepicker.setCompareHandler(this.compareYears, 'year');

    this.datepicker.setKeydownHandler((key: string, event: KeyboardEvent) => {
      this.keydownYears(key, event);
    }, 'year');

    this.datepicker.refreshView();
  }

  protected getStartingYear(year: number): number {
    return Math.floor((year - 1) / this.datepicker.yearRange) * this.datepicker.yearRange + 1;
  }

  private compareYears(date1: Date, date2: Date): number {
    return date1.getFullYear() - date2.getFullYear();
  }

  private refreshYearView() {
    let years: Array<SkyDatepickerDate> = new Array(this.datepicker.yearRange);
    let date: Date;
    let start = this.getStartingYear(this.datepicker.activeDate.getFullYear());

    for (let i = 0; i < this.datepicker.yearRange; i++) {
      date = new Date(this.datepicker.activeDate);
      date.setFullYear(start + i, 0, 1);

      years[i] =
        this.datepicker.createDateObject(
          date,
          this.datepicker.formatYear,
          false,
          this.datepicker.datepickerId + '-' + i
        );
    }

    this.title = [years[0].label,
      years[this.datepicker.yearRange - 1].label].join(' - ');
    this.rows = this.datepicker.createCalendarRows(years, this.datepicker.yearColLimit);
  }

  private keydownYears(key: string, event: KeyboardEvent) {
    let date = this.datepicker.activeDate.getFullYear();

    /* istanbul ignore else */
    /* sanity check */
    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - this.datepicker.yearColLimit;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + this.datepicker.yearColLimit;
    } else if (key === 'pageup' || key === 'pagedown') {
      date += (key === 'pageup' ? - 1 : 1) * this.datepicker.yearRange;
    } else if (key === 'home') {
      date = this.getStartingYear(this.datepicker.activeDate.getFullYear());
    } else if (key === 'end') {
      date
        = this.getStartingYear(
          this.datepicker.activeDate.getFullYear()
          ) + this.datepicker.yearRange - 1;
    }
    this.datepicker.activeDate.setFullYear(date);

  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-yearpicker',
  template: `<table *ngIf="datepicker.datepickerMode==='year'" role="grid">
  <thead>
    <tr>
      <th>
        <button
          type="button"
          class="sky-btn sky-btn-default sky-btn-sm sky-datepicker-btn-previous"
          (click)="datepicker.moveCalendar($event, -1)"
          tabindex="-1"
          >
          <i class="fa fa-chevron-left"></i>
        </button>
      </th>
      <th [attr.colspan]="((datepicker.yearColLimit - 2) <= 0) ? 1 : datepicker.yearColLimit - 2">
        <button
          [id]="datepicker.datepickerId + '-title'"
          role="heading"
          type="button"
          class="sky-btn sky-btn-default sky-btn-sm sky-datepicker-calendar-title"
          (click)="datepicker.toggleModeCalendar($event)"
          [disabled]="datepicker.datepickerMode === datepicker.maxMode"
          [ngClass]="{'sky-btn-disabled': datepicker.datepickerMode === datepicker.maxMode}"
          tabindex="-1"
          >
          <strong>{{title}}</strong>
        </button>
      </th>
      <th>
        <button
          type="button"
          class="sky-btn sky-btn-default sky-btn-sm sky-datepicker-btn-next"
          (click)="datepicker.moveCalendar($event, 1)"
          tabindex="-1"
          >
          <i class="fa fa-chevron-right"></i>
        </button>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of rows">
      <td
        *ngFor="let date of row"
        class="sky-datepicker-row"
        role="gridcell"
        >
        <button
          type="button"
          class="sky-btn sky-btn-default sky-datepicker-btn-date"
          [ngClass]="{'sky-datepicker-btn-selected': date.selected, 'sky-btn-disabled': date.disabled, 'sky-btn-active': datepicker.isActive(date)}"
          [disabled]="date.disabled"
          (click)="datepicker.selectCalendar($event, date.date)"
          tabindex="-1"
          >
          <span
            [ngClass]="{'sky-datepicker-current': date.current }">{{date.label}}</span>
        </button>
      </td>
    </tr>
  </tbody>
</table>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyDatepickerCalendarInnerComponent, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
